import Text from 'components/_UI/Text'
import React from 'react'
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/_UI/Icon';


export default function PrivacyTermPDV() {
    const navigate = useNavigate();

    function goBack() {
        navigate(-1)
    }

    return (
        <Column
            paddingLeft='30px'
            paddingRight='30px'
            paddingTop='20px'
        >

            <StyledRow>
                <ContenButtonBack onClick={goBack}>
                    <StyledButton>
                        <Icon name='back' />
                    </StyledButton>
                    <Text>Voltar</Text>
                </ContenButtonBack>
            </StyledRow>

            <Text name='title'>Política de Privacidade — Whizr Maquininha</Text>

            <Text>Esta Política de Privacidade descreve como o Whizr coleta, usa e protege as informações dos operadores e estabelecimentos que utilizam o aplicativo Whizr Maquininha. Ao utilizar o aplicativo, você concorda com as práticas descritas neste documento.</Text>

            <Text name='highlight' marginTop='20px'>
                <b>1.</b> Informações Coletadas
            </Text>

            <Text name='highlight' marginTop='20px'>
                <b>1.1.</b> Informações de Acesso do Operador:
            </Text>
            <Text paddingBottom='20px'>O aplicativo não realiza cadastro de novos operadores. O acesso é feito com credenciais de uma conta Whizr já existente. As informações utilizadas para autenticação são:</Text>
            <ul>
                <li>
                    <Text>Endereço de e-mail e senha (armazenados com criptografia);</Text>
                </li>
                <li>
                    <Text>Dados do estabelecimento vinculado à conta (nome, segmento de atuação).</Text>
                </li>
            </ul>

            <Text name='highlight' marginTop='20px'>
                <b>1.2.</b> Dados dos Clientes do Estabelecimento:
            </Text>
            <Text paddingBottom='20px'>Durante a abertura de comandas, o operador registra dados dos clientes do estabelecimento por meio do aplicativo. Esses dados são coletados pelo estabelecimento e tratados pelo Whizr na qualidade de operador de dados (conforme a LGPD). As informações coletadas são:</Text>
            <ul>
                <li>
                    <Text>Documento (CPF ou RG) — obrigatório;</Text>
                </li>
                <li>
                    <Text>Nome completo — obrigatório;</Text>
                </li>
                <li>
                    <Text>E-mail e telefone — opcionais.</Text>
                </li>
            </ul>

            <Text name='highlight' marginTop='20px'>
                <b>1.3.</b> Informações de Transações:
            </Text>
            <Text paddingBottom='20px'>Durante o uso do aplicativo, registramos dados relacionados às operações realizadas:</Text>
            <ul>
                <li>
                    <Text>Histórico de vendas, pedidos e pagamentos processados;</Text>
                </li>
                <li>
                    <Text>Dados dos produtos e ingressos comercializados.</Text>
                </li>
            </ul>

            <Text name='highlight' marginTop='20px'>
                <b>2.</b> Uso das Informações
            </Text>

            <Text>As informações coletadas são utilizadas para:</Text>

            <ul>
                <li>
                    <Text>Autenticar o acesso do operador e garantir a segurança da conta;</Text>
                </li>
                <li>
                    <Text>Processar e registrar as transações realizadas no ponto de venda;</Text>
                </li>
                <li>
                    <Text>Validar ingressos e credenciais de participantes em eventos;</Text>
                </li>
                <li>
                    <Text>Gerar relatórios e estatísticas de desempenho para o estabelecimento;</Text>
                </li>
                <li>
                    <Text>Identificar e corrigir falhas técnicas no aplicativo;</Text>
                </li>
                <li>
                    <Text>Cumprir obrigações legais e regulamentares aplicáveis.</Text>
                </li>
            </ul>

            <Text name='highlight' marginTop='20px'>
                <b>3.</b> Compartilhamento de Informações
            </Text>

            <Text>Podemos compartilhar informações nas seguintes situações:</Text>

            <ul>
                <li>
                    <Text>Com prestadores de serviços tecnológicos que nos auxiliam na operação da plataforma (ex.: processadores de pagamento, serviços de hospedagem em nuvem);</Text>
                </li>
                <li>
                    <Text>Com o estabelecimento vinculado ao operador, para fins de gestão e auditoria das operações;</Text>
                </li>
                <li>
                    <Text>Em resposta a exigências legais, ordens judiciais ou para a proteção de direitos do Whizr e de terceiros.</Text>
                </li>
            </ul>

            <Text>Não vendemos, alugamos ou compartilhamos dados pessoais com terceiros para fins de marketing sem o consentimento explícito do titular.</Text>

            <Text name='highlight' marginTop='20px'>
                <b>4.</b> Retenção de Dados
            </Text>

            <Text>Mantemos os dados pelo tempo necessário para a prestação do serviço e cumprimento de obrigações legais. Após o encerramento da conta, os dados podem ser retidos por até 5 (cinco) anos para fins de auditoria fiscal e compliance, conforme a legislação brasileira.</Text>

            <Text name='highlight' marginTop='20px'>
                <b>5.</b> Proteção das Informações
            </Text>

            <Text>Adotamos medidas técnicas e organizacionais adequadas para proteger as informações contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui criptografia em trânsito (HTTPS/TLS), autenticação com token e controles de acesso por função (RBAC). Nenhum sistema é 100% inviolável, e recomendamos que os operadores mantenham suas credenciais em sigilo.</Text>

            <Text name='highlight' marginTop='20px'>
                <b>6.</b> Seus Direitos (LGPD)
            </Text>

            <Text>Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), o titular dos dados tem direito a:</Text>

            <ul>
                <li>
                    <Text>Confirmar a existência de tratamento de seus dados;</Text>
                </li>
                <li>
                    <Text>Acessar, corrigir ou atualizar seus dados pessoais;</Text>
                </li>
                <li>
                    <Text>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários;</Text>
                </li>
                <li>
                    <Text>Revogar o consentimento a qualquer momento, quando o tratamento for baseado nele;</Text>
                </li>
                <li>
                    <Text>Solicitar a portabilidade dos dados a outro fornecedor de serviço.</Text>
                </li>
            </ul>

            <Text>Para exercer esses direitos, entre em contato pelo e-mail: <b>contato@whizr.app</b></Text>

            <Text name='highlight' marginTop='20px'>
                <b>7.</b> Alterações nesta Política
            </Text>

            <Text marginBottom='40px'>Reservamos o direito de atualizar esta Política de Privacidade a qualquer momento. Alterações relevantes serão comunicadas por e-mail ou por notificação dentro do próprio aplicativo. O uso continuado do Whizr Maquininha após as alterações implica concordância com a nova versão da política.</Text>

        </Column>
    )
}

const StyledRow = styled(Row)`
    width: 100%;
    justify-content: center;
`;

const ContenButtonBack = styled.div`
    display: flex;
    flex-direction: row;
    width: 80px;
    height: 40px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all ease-in-out .25s;
    & > p {
        padding-bottom: 0px;
        font-size: 16px;
        margin-left: 5px;
        color: ${colors.primaryDashboard}
    }

    &:hover {
        transform: scale(1.02)
    }
`;

const StyledButton = styled(Row)`
    width: 26px;
    padding: 5px;
    height: 26px;
    border-radius: 50%;
`;
